// extracted by mini-css-extract-plugin
export default {"table":"DoubleMissedLegTable_table__-dPOv","header":"DoubleMissedLegTable_header__gIR8v","valueCell":"DoubleMissedLegTable_valueCell__ASZYc"};